/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiPreemptionResult
 */
export interface ApiPreemptionResult {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ApiPreemptionResult
     */
    preemptionResults?: { [key: string]: string; };
}

export function ApiPreemptionResultFromJSON(json: any): ApiPreemptionResult {
    return ApiPreemptionResultFromJSONTyped(json, false);
}

export function ApiPreemptionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiPreemptionResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'preemptionResults': !exists(json, 'preemptionResults') ? undefined : json['preemptionResults'],
    };
}

export function ApiPreemptionResultToJSON(value?: ApiPreemptionResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'preemptionResults': value.preemptionResults,
    };
}

